import sx from '../../sx.js';
import React__default from 'react';
import styled from 'styled-components';
import Box from '../Box/Box.js';

const Wrapper = styled(Box).withConfig({
  displayName: "ArcadeWrapper__Wrapper",
  componentId: "sc-1k0byay-0"
})(["--shadow-color:0deg 0% 0%;--shadow-elevation-low:0.3px 0.5px 0.9px hsl(var(--shadow-color) / 0),0.8px 1.6px 2.7px hsl(var(--shadow-color) / 0.09);--shadow-elevation-medium:0.3px 0.5px 0.9px hsl(var(--shadow-color) / 0),1.4px 2.8px 4.7px hsl(var(--shadow-color) / 0.05),3.9px 7.9px 13.2px hsl(var(--shadow-color) / 0.11);--shadow-elevation-high:0.3px 0.5px 0.9px hsl(var(--shadow-color) / 0),2.5px 5px 8.4px hsl(var(--shadow-color) / 0.04),4.7px 9.4px 15.8px hsl(var(--shadow-color) / 0.07),8.3px 16.5px 27.7px hsl(var(--shadow-color) / 0.11),14.5px 29px 48.6px hsl(var(--shadow-color) / 0.15);--box-shadow:0.3px 0.5px 0.9px hsl(var(--shadow-color) / 0),2.5px 5px 8.4px hsl(var(--shadow-color) / 0.04),4.7px 9.4px 15.8px hsl(var(--shadow-color) / 0.07),8.3px 16.5px 27.7px hsl(var(--shadow-color) / 0.11),14.5px 29px 48.6px hsl(var(--shadow-color) / 0.15);box-shadow:var(--box-shadow);border-radius:8px;"]);
const IFrame = styled(Box).withConfig({
  displayName: "ArcadeWrapper__IFrame",
  componentId: "sc-1k0byay-1"
})(["", ""], sx);

/**
 * Opinionated wrapper used for product demo animations
 */
const ArcadeWrapper = ({
  title,
  href,
  ...props
}) => {
  return /*#__PURE__*/React__default.createElement(Wrapper, {
    sx: {
      position: 'relative',
      paddingBottom: '50.2825%',
      height: '0',
      flex: 1
    }
  }, /*#__PURE__*/React__default.createElement(IFrame, {
    as: "iframe",
    src: href,
    frameBorder: "0",
    loading: "lazy",
    allowFullScreen: true,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      colorScheme: 'light'
    },
    title: title
  }));
};
ArcadeWrapper.displayName = "ArcadeWrapper";
var ArcadeWrapper$1 = ArcadeWrapper;

export { ArcadeWrapper$1 as default };
